<app-uni-page [parent]="this" pageTitle="References: Box Sizes" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate">
</app-uni-page>
<ng-template #bodyTemplate>
  <div *ngIf="isPageReady" class="flex flex-col w-2/3 h-full">
    <div class="qb-list-actions">
      <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-plus" (click)="editBoxSize()">
        <span>Add Box Size</span>
      </button>
    </div>
    <app-ag-grid [gridOptions]="boxSizeGridOptions" [rowData]="boxSizes" class="flex-1 min-h-0"></app-ag-grid>
  </div>
</ng-template>
<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
